import React, { Component } from "react";
import { bool } from "prop-types";
import formField from "pages/forms/_components/_fields/_commons/formField";

class Horizontalrule extends Component {
    static propTypes = {
        editing: bool.isRequired,
    };

    render() {
        const { editing } = this.props;
        if (editing) {
            return <hr />;
        }
        return null;
    }
}

export default formField({ pureRender: true })(Horizontalrule);
